<template>
  <!-- Нижний таб-бар (мобильный): только вкладки, никогда не подменяется
       контекстными действиями (они живут в самих панелях). joined - над ним
       вплотную панель поиска (MobileMapOverlay): одна поверхность, границу
       сверху рисует она. -->
  <nav :aria-label="$t('app.navLabel')" class="flex items-stretch justify-around h-[60px] bg-card" :class="joined ? '' : 'border-t border-border'">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      class="flex-1 flex flex-col items-center justify-center gap-0.5 min-w-0 text-[11px] font-medium"
      :class="active === tab.key ? 'text-primary' : 'text-muted-foreground'"
      :aria-current="active === tab.key ? 'page' : undefined"
      @click="$emit('select', tab.key)"
    >
      <span
        class="relative flex items-center justify-center w-16 h-9 rounded-full transition-colors duration-150"
        :class="active === tab.key ? 'bg-primary/10' : ''"
      >
        <component :is="tab.icon" class="w-[22px] h-[22px]" aria-hidden="true" />
        <span v-if="badges?.[tab.key]" class="absolute -top-0.5 right-1 h-2.5 w-2.5 rounded-full bg-destructive ring-2 ring-card" aria-hidden="true" />
        <span v-if="badges?.[tab.key]" class="sr-only">{{ $t('notifications.unreadDot') }}</span>
      </span>
      <span class="sr-only">{{ tab.label }}</span>
    </button>
    <button type="button" class="flex-1 flex flex-col items-center justify-center gap-0.5 min-w-0 text-[11px] font-medium text-muted-foreground" @click="$emit('feedback')">
      <span class="flex items-center justify-center w-16 h-9 rounded-full">
        <MessageSquare class="w-[22px] h-[22px]" aria-hidden="true" />
      </span>
      <span class="sr-only">{{ $t('app.feedbackButton') }}</span>
    </button>
  </nav>
</template>

<script setup lang="ts">
import type { Component } from "vue";
import { MessageSquare } from "lucide-vue-next";
import type { TabKey } from "../../utils/navigation";

defineProps<{ active: TabKey; tabs: { key: TabKey; label: string; icon: Component }[]; badges?: Partial<Record<TabKey, boolean>>; joined?: boolean }>();
defineEmits<{ (e: "select", key: TabKey): void; (e: "feedback"): void }>();
</script>
